import React from "react";
import CroppedText from "sulu-admin-bundle/components/CroppedText";
import SingleSelect from "sulu-admin-bundle/components/SingleSelect";
import { toJS } from "mobx";
import { translate as suluTranslate } from "sulu-admin-bundle/utils";

const Option = SingleSelect.Option;

const headerColums = (props) => {
    const firstname = props?.t("sulu_admin.match.firstname");
    const lastname = props?.t("sulu_admin.match.lastname");
    const role = props?.t("sulu_admin.match.function");

    const hC = (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "repeat(5, 1fr)",
                width: "80%",
            }}
        >
            <div> {lastname}</div>
            <div> {firstname}</div>
            <div> {role}</div>
            <div style={{ paddingLeft: "24px" }}> Pass-Nr.</div>
        </div>
    );

    return hC;
};

const inputNumb = (
    item,
    displayProperty,
    itemClickHandler,
    aditionalParams = "",
    data
) => {
    let roles = toJS(data.teamRoleList);

    if (
        aditionalParams["staffRoles"] &&
        aditionalParams["staffRoles"].length > 0
    ) {
        roles = aditionalParams["staffRoles"];
    }

    if (!roles) {
        return "";
    }

    return (
        <div style={{ maxWidth: "8rem", width: "100%" }}>
            <SingleSelect
                name={displayProperty}
                value={roles ? roles[item[displayProperty]] : ""}
                onChange={(value) => {
                    itemClickHandler(value, item.id, displayProperty);
                }}
            >
                {Object.values(roles).map((el, index) => {
                    return (
                        <Option key={index} value={el}>
                            {el}
                        </Option>
                    );
                })}
            </SingleSelect>
        </div>
    );
};
const columnCustom = (
    item,
    itemColumnClass,
    itemClickHandler,
    displayProperty,
    columns,
    inputNumb,
    aditionalParams = "",
    data
) => {
    const renderContent = () => {
        switch (displayProperty) {
            case "role":
            case "position":
                return inputNumb(
                    item,
                    displayProperty,
                    itemClickHandler,
                    aditionalParams,
                    data
                );
            case "lastName":
                return item.lastName;
            case "firstName":
                return item.firstName;
            default:
                return <CroppedText>{item[displayProperty]}</CroppedText>;
        }
    };

    return (
        <div
            className={itemColumnClass}
            key={`${displayProperty}-${item.id}`}
            style={
                ["lastName", "firstName", "role"].indexOf(displayProperty) ===
                -1
                    ? { paddingLeft: "27px" }
                    : { paddingLeft: "0" }
            }
        >
            {renderContent()}
        </div>
    );
};

const footer = (
    noOfSelectedPlayer,
    minPlayers,
    maxPlayers,
    dataPath,
    hideLegend,
    translate,
    minStaff,
    maxStaff
) => {
    const minStaffNumber = minStaff - noOfSelectedPlayer;
    const maxStaffNumber = noOfSelectedPlayer - maxStaff;

    const warningMessage =
        noOfSelectedPlayer < minStaff
            ? suluTranslate("sulu_admin.match.staff_min", {
                  number: minStaffNumber,
              })
            : noOfSelectedPlayer > maxStaff
            ? suluTranslate("sulu_admin.match.staff_max", {
                  number: maxStaffNumber,
              })
            : "";

    const numberColor = {
        color:
            noOfSelectedPlayer < minStaff
                ? "red"
                : noOfSelectedPlayer > maxStaff
                ? "red"
                : "green",
    };

    return (
        <>
            <div
                style={{
                    backgroundColor: "#E5E5E5",
                    fontSize: "16px",
                    padding: "10px 20px",
                    border: "1px solid #DDDDDD",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                }}
            >
                Staff gesamt {noOfSelectedPlayer}
                <strong style={numberColor}>
                    ({`${minStaff} - ${maxStaff}`})
                </strong>
                {warningMessage && (
                    <div
                        style={{
                            color: "red",
                            fontSize: "12px",
                        }}
                    >
                        {warningMessage}
                    </div>
                )}
            </div>
        </>
    );
};

export { headerColums as hackHeader, inputNumb, columnCustom, footer };
